module.exports = __webpack_public_path__ + "Lato-BoldItalic.1ba4767ee37aab7e8d34";


//////////////////
// WEBPACK FOOTER
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/assets/fonts/Lato/Lato-BoldItalic.ttf
// module id = ../../../../../src/assets/fonts/Lato/Lato-BoldItalic.ttf
// module chunks = styles